import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoOutlined, LockOutlined } from "@mui/icons-material";
import { Box, FormControl, FormHelperText, FormLabel, InputAdornment, MenuItem, Select, Stack } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useId } from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IconTooltip } from "./IconTooltip";
export const SelectInput = (props)=>{
    const labelId = useId();
    const errorId = useId();
    const labelInfoId = useId();
    const formContext = useFormContext();
    const translation = useTranslation();
    const error = get(formContext.formState.errors, props.name);
    return /*#__PURE__*/ _jsx(Controller, {
        control: formContext.control,
        name: props.name,
        render: ({ field })=>/*#__PURE__*/ _jsxs(FormControl, {
                error: !!error,
                fullWidth: props.fullWidth,
                required: props.required,
                size: props.size,
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ _jsx(FormLabel, {
                                disabled: props.disabled,
                                id: labelId,
                                required: props.required,
                                children: props.label
                            }),
                            props.labelInfo && /*#__PURE__*/ _jsx(IconTooltip, {
                                "aria-label": `${props.label} more info`,
                                trigger: /*#__PURE__*/ _jsx(InfoOutlined, {
                                    color: "primary",
                                    fontSize: "small"
                                }),
                                children: props.labelInfo
                            })
                        ]
                    }),
                    props.labelInfo && /*#__PURE__*/ _jsx(Box, {
                        component: "span",
                        id: labelInfoId,
                        sx: visuallyHidden,
                        children: props.labelInfo
                    }),
                    /*#__PURE__*/ _jsxs(Select, {
                        ...field,
                        "data-testid": props.name,
                        disabled: props.disabled,
                        displayEmpty: true,
                        error: !!error,
                        fullWidth: props.fullWidth,
                        inputProps: {
                            'aria-describedby': props.labelInfo ? `${labelInfoId} ${errorId}` : errorId,
                            'aria-disabled': !!props.disabled,
                            'aria-labelledby': labelId,
                            'aria-live': 'polite',
                            'aria-required': !!props.disabled
                        },
                        MenuProps: {
                            keepMounted: true
                        },
                        onChange: field.onChange,
                        size: props.size,
                        startAdornment: props.disabled ? /*#__PURE__*/ _jsx(InputAdornment, {
                            position: "start",
                            children: props.startAdornmentTooltip ? /*#__PURE__*/ _jsx(IconTooltip, {
                                size: "medium",
                                trigger: /*#__PURE__*/ _jsx(LockOutlined, {}),
                                children: props.startAdornmentTooltip
                            }) : /*#__PURE__*/ _jsx(LockOutlined, {})
                        }) : props.startAdornmentIcon ? /*#__PURE__*/ _jsx(InputAdornment, {
                            position: "start",
                            children: props.startAdornmentTooltip ? /*#__PURE__*/ _jsx(IconTooltip, {
                                size: "medium",
                                trigger: props.startAdornmentIcon,
                                children: props.startAdornmentTooltip
                            }) : props.startAdornmentIcon
                        }) : props.startAdornment,
                        variant: props.variant,
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                disabled: true,
                                value: "",
                                children: props.placeholder
                            }),
                            props.options.map((option)=>/*#__PURE__*/ _jsx(MenuItem, {
                                    "data-testid": option.label,
                                    value: option.value,
                                    children: option.label
                                }, option.value))
                        ]
                    }),
                    !props.hideError && /*#__PURE__*/ _jsx(FormHelperText, {
                        id: errorId,
                        children: translation.t(error?.message) || ' '
                    })
                ]
            })
    });
};
SelectInput.displayName = 'SelectInput';

//# sourceMappingURL=SelectInput.js.map